module.exports = __webpack_public_path__ + "static/img/3areaA_7.69721e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/3areaA_7.png
// module id = 814
// module chunks = 1